<template>
  <div v-loading="loading">
    <!-- 数据报告头部 -->
		<div class="report-header m-b-24">
			<p class="text right margin">
				<el-button type="primary" size="small" plain @click="generateDataReport">导出数据报告</el-button>
			</p>
      <el-form size="small" label-width="100px">
        <el-row :gutter="24">
					<el-col :span="8">
						<el-form-item label="公司">
							<el-checkbox v-model="reqSearch.companyIdsFlag" class="item-left"></el-checkbox>
							<el-select v-model="reqSearch.companyId" placeholder="请选择" filterable clearable class="item-right"  @change="companyChange">
								<el-option
								v-for="item in companyOption"
								:key="item.id"
								:label="item.companyName"
								:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
          <el-col :span="8">
							<el-form-item label="策略组">
                <el-checkbox v-model="reqSearch.groupIdFlag" class="item-left"></el-checkbox>
                <el-select v-model="reqSearch.groupId" placeholder="请选择" clearable class="item-right">
                    <el-option
                    v-for="item in groupOption"
                    :key="item.id"
                    :label="item.groupName"
                    :value="item.id">
                    </el-option>
                </el-select>
							</el-form-item>
					</el-col>
					<el-col :span="8">
							<el-form-item label="导入时间">
                <el-checkbox checked disabled class="item-left"></el-checkbox>
                <el-date-picker class="item-right"
                    v-model="importTime"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
							</el-form-item>
					</el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="批次号">
              <el-checkbox v-model="reqSearch.batchNosFlag" class="item-left"></el-checkbox>
              <batch-selector v-model="searchTemp.batchNos" :batchNo="batchNoDefault" :testing="true" class="item-right"></batch-selector>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="展示天数">
                <el-checkbox checked disabled class="item-left"></el-checkbox>
                <el-select v-model="reqSearch.collectDays" placeholder="请选择" class="item-right">
                    <el-option
                    v-for="item in 7"
                    :key="item"
                    :label="item"
                    :value="item">
                    </el-option>
                </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <div class="text right">
              <el-button size="mini" type="text" v-show="!otherSearchShow" @click="otherSearchShow = true">展开<el-icon class="el-icon-arrow-down"></el-icon></el-button>
              <el-button size="mini" type="text" v-show="otherSearchShow" @click="otherSearchShow = false">收缩<el-icon class="el-icon-arrow-up"></el-icon></el-button>
            </div>
          </el-col>
        </el-row>
        <div class="display-field-wrapper">
					<transition name="component-fade" mode="out-in">
            <div v-show="otherSearchShow" class="display-fields-options">
              <el-row :gutter="24">
                <el-col :span="4">
                  <el-form-item label="作业天数">
                    <el-checkbox v-model="reqSearch.averagePlayDaysFlag"></el-checkbox>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="逾期天数">
                    <el-checkbox v-model="reqSearch.averageOverdueDatesFlag"></el-checkbox>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="件均短信发送数" label-width="180px;">
                    <el-checkbox v-model="reqSearch.averageMsgSendCountFlag"></el-checkbox>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="件均IVR发送数" label-width="180px;">
                    <el-checkbox v-model="reqSearch.averageIvrSendCountFlag"></el-checkbox>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="总户数">
                    <el-checkbox v-model="reqSearch.caseTotalCountFlag"></el-checkbox>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="回退户数">
                    <el-checkbox v-model="reqSearch.caseReturnCountFlag"></el-checkbox>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="4">
                  <el-form-item label="回退率">
                    <el-checkbox v-model="reqSearch.caseReturnRateFlag"></el-checkbox>
                  </el-form-item>
                </el-col>
                <!--
                <el-col :span="4">
                  <el-form-item label="总金额" label-width="180px;">
                    <el-checkbox v-model="reqSearch.caseTotalAmountFlag"></el-checkbox>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="回退金额" label-width="180px;">
                    <el-checkbox v-model="reqSearch.caseTotalReturnAmountFlag"></el-checkbox>
                  </el-form-item>
                </el-col>
                -->
              </el-row>
            </div>
					</transition>
        </div>
        <div class="padding15-tb text right">
          <el-button type="primary" size="small" @click="search" :disabled="loading">搜索</el-button>
          <el-button type="default" size="small" @click="reset" :disabled="loading">重置</el-button>
        </div>
			</el-form>
		</div>
    <!-- 数据报告内容 -->
    <div class="report-content">
        <el-table
            :data="reportData"
            size="small">
            <el-table-column
            fixed
            width="140px"
            align="center"
            prop="companyName"
            v-if="tableColumnShow.companyIdsFlag"
            label="公司">
            </el-table-column>
            <el-table-column
            width="120px"
            align="center"
            prop="importTime"
            label="案件导入时间">
            </el-table-column>
            <el-table-column
            width="90px"
            align="center"
            prop="averagePlayDays"
            v-if="tableColumnShow.averagePlayDaysFlag"
            label="作业天数">
            </el-table-column>
            <el-table-column
            width="160px"
            align="center"
            prop="batchNos"
            v-if="tableColumnShow.batchNosFlag"
            label="批次号">
            </el-table-column>
            <el-table-column
            width="140px"
            align="center"
            prop="groupName"
            v-if="tableColumnShow.groupIdFlag"
            label="策略组">
            </el-table-column>
            <el-table-column
            width="80px"
            align="center"
            prop="averageOverdueDates"
            v-if="tableColumnShow.averageOverdueDatesFlag"
            label="逾期天数">
            </el-table-column>
            <el-table-column
            width="80px"
            align="center"
            prop="caseTotalAmount"
            v-if="tableColumnShow.caseTotalAmountFlag"
            label="总金额(万)">
            <template slot-scope="scope">
                ￥{{scope.row.caseTotalAmount}}
            </template>
            </el-table-column>
            <el-table-column
            width="80px"
            align="center"
            prop="caseTotalReturnAmount"
            v-if="tableColumnShow.caseTotalReturnAmountFlag"
            label="回退金额(万)">
            <template slot-scope="scope">
                ￥{{scope.row.caseTotalReturnAmount}}
            </template>
            </el-table-column>
            <el-table-column
            width="80px"
            align="center"
            prop="caseTotalCount"
            v-if="tableColumnShow.caseTotalCountFlag"
            label="总户数">
            </el-table-column>
            <el-table-column
            width="80px"
            align="center"
            prop="caseReturnCount"
            v-if="tableColumnShow.caseReturnCountFlag"
            label="回退户数">
            </el-table-column>
            <el-table-column
            width="80px"
            align="center"
            prop="caseReturnRate"
            v-if="tableColumnShow.caseReturnRateFlag"
            label="回退率">
            </el-table-column>
            <el-table-column
            width="80px"
            align="center"
            prop="averageMsgSendCount"
            v-if="tableColumnShow.averageMsgSendCountFlag"
            label="件均短信发送数">
            </el-table-column>
            <el-table-column
            width="80px"
            align="center"
            prop="averageIvrSendCount"
            v-if="tableColumnShow.averageIvrSendCountFlag"
            label="件均IVR发送数">
            </el-table-column>
            <el-table-column
            label="总回退率"
            align="center">
              <el-table-column v-for="item in reqSearch.collectDays" :label="'' + item" align="center" :key="item" >
                  <template slot-scope="scope">
                  {{scope.row[`totalReturnRate${item}`]}}
                  </template>
              </el-table-column>
            </el-table-column>
            <el-table-column
            label="触达率"
            align="center">
              <el-table-column v-for="item in reqSearch.collectDays" :label="'' + item" align="center" :key="item">
                  <template slot-scope="scope">
                  {{scope.row[`touchtRate${item}`]}}
                  </template>
              </el-table-column>
            </el-table-column>
            <el-table-column
            label="回复率"
            align="center">
              <el-table-column v-for="item in reqSearch.collectDays" :label="'' + item" align="center" :key="item">
                  <template slot-scope="scope">
                  {{scope.row[`contactRate${item}`]}}
                  </template>
              </el-table-column>
            </el-table-column>
            <el-table-column
            label="回复回退率"
            align="center">
              <el-table-column v-for="item in reqSearch.collectDays" :label="'' + item" align="center" :key="item">
                  <template slot-scope="scope">
                  {{scope.row[`contactReturnRate${item}`]}}
                  </template>
              </el-table-column>
            </el-table-column>
            <el-table-column
            label="非回复回退率"
            align="center">
              <el-table-column v-for="item in reqSearch.collectDays" :label="'' + item" align="center" :key="item">
                  <template slot-scope="scope">
                  {{scope.row[`noContactReturnRate${item}`]}}
                  </template>
              </el-table-column>
            </el-table-column>
        </el-table>
        <div class="text center margin15-tb">
            <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageData.currentPage"
            :page-sizes="[50, 100, 200]"
            :page-size="pageData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageData.totalCount">
            </el-pagination>
        </div>
    </div>
  </div>
</template>
<script>
import BatchSelector from '../../../../components/bussiness-select/BatchSelector';

export default {
  inject: ['reload'],
  // props: [
  //   'changeTabe'
  // ],
  // watch: {
  //   changeTabe(type) {
  //     if (type === 'report') {
  //       sessionStorage.setItem('dataReportType', '');
  //       this.setImportDay();
  //       this.getData(1);
  //       this.getCompanyOptionList();
  //     }
  //   }
  // },
  data() {
    return {
      activeTab: 'report',
      reqSearch: {
        companyIdsFlag: true,
        companyId: '',
        groupIdFlag: false,
        groupId: '',
        batchNosFlag: false,
        batchNos: '',
        collectDays: 3,
        averagePlayDaysFlag: true,
        averageOverdueDatesFlag: true,
        averageMsgSendCountFlag: true,
        averageIvrSendCountFlag: true,
        caseReturnCountFlag: true,
        caseReturnRateFlag: true,
        caseTotalAmountFlag: false,
        caseTotalReturnAmountFlag: false,
        caseTotalCountFlag: true
      },
      groupReq: {},
      companyOption: [],
      groupOption: [],
      batchNoOption: [],
      importTime: [],
      pageData: {},
      otherSearchShow: false,
      reportData: [],
      // 限制导出时间-数据报告
      exportTimeData: '',
      loading: '',
      tableColumnShow: {},
      searchTemp: {
        batchNos: []
      },
      batchNoDefault: []
    };
  },
  mounted() {
    this.$router.push({ path: `${this.$route.path}?report=数据报告` });
    this.setImportDay();
    this.getData(1);
    this.getCompanyOptionList();
  },
  methods: {
    // 查询列表
    getData(page) {
      this.reportData = [];
      this.loading = true;
      this.getSearchParam(page);
      this.$ajax({
        url: '/report/getRunReportData',
        method: 'POST',
        data: this.reqSearch
      }).then((res) => {
        this.loading = false;
        this.tableColumnShow = {
          companyIdsFlag: this.reqSearch.companyIdsFlag,
          groupIdFlag: this.reqSearch.groupIdFlag,
          batchNosFlag: this.reqSearch.batchNosFlag,
          averagePlayDaysFlag: this.reqSearch.averagePlayDaysFlag,
          averageOverdueDatesFlag: this.reqSearch.averageOverdueDatesFlag,
          averageMsgSendCountFlag: this.reqSearch.averageMsgSendCountFlag,
          averageIvrSendCountFlag: this.reqSearch.averageIvrSendCountFlag,
          caseReturnCountFlag: this.reqSearch.caseReturnCountFlag,
          caseReturnRateFlag: this.reqSearch.caseReturnRateFlag,
          caseTotalAmountFlag: this.reqSearch.caseTotalAmountFlag,
          caseTotalReturnAmountFlag: this.reqSearch.caseTotalReturnAmountFlag,
          caseTotalCountFlag: this.reqSearch.caseTotalCountFlag
        };
        this.reportData = res.data.list;
        this.pageData.pageSize = res.data.limit;
        this.pageData.totalCount = res.data.totalRecords;
        this.pageData.currentPage = res.data.currentPage;
      });
    },
    // 设置查询的向后台参数
    getSearchParam(page) {
      if (!this.importTime || !this.importTime[0] || !this.importTime[1]) {
        this.setImportDay();
      }
      this.reqSearch.importTimeStart = this.importTime[0];
      this.reqSearch.importTimeEnd = this.importTime[1];
      this.reqSearch.page = page;
      this.reqSearch.limit = this.pageData.pageSize || 50;
      this.reqSearch.order = 0;
      this.reqSearch.sort = 0;
      this.reqSearch.batchNos = this.searchTemp.batchNos ? this.searchTemp.batchNos.join(',') : '';
    },
    // 每页条数
    handleSizeChange(val) {
      this.pageData.pageSize = val;
      this.getData(1);
    },
    // 页码
    handleCurrentChange(val) {
      this.pageData.currentPage = val;
      this.getData(val);
    },
    // 搜索
    search() {
      this.getData(1);
    },
    // 重置
    reset() {
      sessionStorage.setItem('dataReportType', 'report');
      const type = sessionStorage.getItem('dataReportType');
      console.warn(type);
      this.reload();
    },
    // 设置前七天
    setImportDay() {
      const startDay = new Date();
      startDay.setTime(new Date().getTime() - (7 * 24 * 60 * 60 * 1000));// 7天前
      const endDay = new Date();
      this.importTime = [''.concat(startDay.getFullYear(), '-', (startDay.getMonth() + 1), '-', startDay.getDate()), ''.concat(endDay.getFullYear(), '-', (endDay.getMonth() + 1), '-', endDay.getDate())];
    },
    // 公司列表
    getCompanyOptionList() {
      this.$ajax({
        url: '/company/getCompanyListJudgeRole',
        method: 'get'
      }).then((res) => {
        this.companyOption = res.data;
        if (!this.$partB()) {
          this.reqSearch.companyId = this.companyOption[0].id;
          this.companyChange();
        }
      });
    },
    // 公司改变查对应的策略组可选项
    companyChange() {
      this.groupReq.companyId = this.reqSearch.companyId;
      this.getGroupOptionList(this.groupReq);
    },
    // 获取策略组
    getGroupOptionList(dataReq) {
      this.$ajax({
        url: '/strategy/selectAllGroupsByCompanyIdOfUserNew',
        method: 'POST',
        data: dataReq
      }).then((res) => {
        this.groupOption = res.data;
      });
    },
    // 生成数据日报
    generateDataReport() {
      const nowLong = new Date().getTime();
      if (this.exportTimeData && (nowLong - this.exportTimeData.getTime()) < 1000 * 60 * 10) {
        this.$confirm('您已经生成过了，休息几分钟再生成数据吧', '提示', {
          type: 'warning',
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        });
        return false;
      }
      this.getSearchParam(1);
      this.exportTimeData = new Date();
      this.$ajax({
        url: '/report/generateDataReport',
        method: 'POST',
        data: this.reqSearch,
        prompt: true
      });
      return true;
    }
  },
  components: {
    BatchSelector
  }
};
</script>
<style lang="less" scoped>
.report-header {
  .display-field-wrapper {
    padding-left: 100px;
    .display-fields-options {
      background: #f7f7f7;
    }
  }
  .item-left {
    width: 10%;
  }
  .item-right {
    width: 90%; float: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/main/collection/report/dataReport.vue